export default __webpack_public_path__ + "static/favicon-125644b36aa4869eb7460205db8c15fc.ico";